import { ReactElement } from 'react';

import { IconButton as ButtonIcon, Tooltip } from '@material-ui/core';

import { useStyles } from './styles';

type ToolbarButtonProps = {
  label: string;
  icon: ReactElement;
  onClick: () => void;
};

export const ToolbarButton = ({ label, icon, onClick }: ToolbarButtonProps) => {
  const classes = useStyles();

  return (
    <Tooltip title={label}>
      <ButtonIcon
        aria-label={label}
        onClick={onClick}
        size="small"
        className={classes.button}
        data-track-id={`button.toolbar-${label.toLowerCase().replace(/\s+/g, '-')}`}
        data-track-action="update"
      >
        {icon}
      </ButtonIcon>
    </Tooltip>
  );
};
